import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";

function Section1() {
  return (
    <Box sx={{ width: "100%" }}>
      {/* Hero Section */}
      <Box
        sx={{
          mt: { xs: 8, sm: 10, md: 12 }, // Added responsive margin-top
          backgroundImage:
            'url("https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1920&auto=format&fit=crop&q=80")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: { xs: "350px", sm: "400px", md: "500px" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          mb: { xs: 4, md: 6 },
          px: { xs: 2, md: 0 },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#ffffff",
              mb: 1,
              fontSize: { xs: "24px", sm: "28px", md: "42px" },
              lineHeight: { xs: 1.3, sm: 1.4, md: 1.2 },
            }}
          >
            Premium Car Cleaning Services
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#ffffff",
              fontSize: { xs: "16px", sm: "18px", md: "20px" },
              mb: 3,
            }}
          >
            Your Car Deserves the Best
          </Typography>

          {/* Call-to-Action Button */}
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#4169E1",
              color: "#000",
              fontWeight: "bold",
              px: { xs: 3, sm: 4 },
              py: { xs: 1, sm: 1.5 },
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
              borderRadius: "30px",
              textTransform: "none",
              boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
              "&:hover": {
                backgroundColor: "#4169E1",
              },
            }}
          >
            Book Now
          </Button>
        </Container>
      </Box>
    </Box>
  );
}

export default Section1;
